import React, { useState, useEffect } from "react";
import {
  Tooltip,
  LinkButton,
  InputText,
  SeparatorLine,
  Instruction,
  CardButton,
  StepperBar
} from "components/CommonUI";
import { Dropdown } from "react-bootstrap";

const BreadCrumb = () => {
  return (
    <div className="breadcrumb">
      <div className="cmp-breadcrumb dark-mode">
        <nav className="cmp-breadcrumb" aria-label="Breadcrumb">
          <ol className="cmp-breadcrumb__list breadcrumb--default breadcrumb--tablet">
            <li className="cmp-breadcrumb__item">
              <a href="/member" className="cmp-button cmp-button--link">
                <span className="cmp-button__text">Home</span>
                <span className="icons_space icon-dls-arrow-right"></span>
              </a>
            </li>

            <li className="cmp-breadcrumb__item">
              <a
                href="/member/tools-and-services"
                className="cmp-button cmp-button--link"
              >
                <span className="cmp-button__text">Tools and services</span>
                <span className="icons_space icon-dls-arrow-right"></span>
              </a>
            </li>

            <li className="cmp-breadcrumb__item">
              <a
                href="/member/tools-and-services/forms-e-applications"
                className="cmp-button cmp-button--link"
              >
                <span className="cmp-button__text">
                  Forms and e-applications
                </span>
                <span className="icons_space icon-dls-arrow-right"></span>
              </a>
            </li>

            <li className="cmp-breadcrumb__item cmp-breadcrumb__item--active">
              <span>Cash top-ups and CPF transfers for retirement</span>
            </li>
          </ol>
          <ol className="cmp-breadcrumb__list breadcrumb--phone">
            <li className="cmp-breadcrumb__item">
              <a
                href="/member/tools-and-services/forms-e-applications"
                className="cmp-button cmp-button--link"
              >
                <span className="icons_space icon-dls-arrow-left"></span>
                <span className="cmp-button__text">
                  Forms and e-applications
                </span>
              </a>
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
};

const Disclaimer = () => {
  return (
    <fieldset className="cmp-form-options cmp-form-options--radio cta-bar__inner">
      <label className="cmp-form-options__field-label">
        <input
          className="cmp-form-options__field cmp-form-options__field--checkbox"
          id="coverCheckbox"
          type="checkbox"
        />

        <div className="cmp-form-options__field-description">
          <p style={{ marginBottom: 0 }}>
            I have read and accepted the&nbsp;
            <a href="/member/terms-of-use#Disclaimer" target="_blank">
              Disclaimer
            </a>
            .
          </p>
        </div>
      </label>
    </fieldset>
  );
};

export const Radio = ({ value, onChange, checked, label }) => {
  // const [val, setVal] = useState(value);

  const selectedClass = checked ? "guideRadioSelected" : "";
  console.log("checked", checked);

  return (
    <div
      className="guideFieldWidget guideFieldVerticalAlignment col-12 XfaCheckBox"
      data-original-title=""
      title=""
      onClick={() => {
        onChange({ target: { value } });
      }}
    >
      <label
        className={`guideRadio guideRadioButtonItem afRadioButtonItem radiotopup topup-type ${selectedClass}`}
        data-id="1"
        name="guideContainer-rootPanel-progressPanel-step1-guideradiobutton___jqName"
        tabindex="0"
        aria-label="PayNow QR"
        aria-required="true"
        aria-checked="false"
        placeholder=""
        data-original-title=""
        title=""
      >
        <span className="guideRadioInput">
          <input
            type="radio"
            id="guideContainer-rootPanel-progressPanel-step1-guideradiobutton__-1_widget"
            data-element-name="radiotopup"
            name="radiotopup"
            value={value}
            // aria-required="true"
            style={{ position: "relative" }}
            element-name="radiotopup"
          />
          <span className="guideRadioControl"></span>
        </span>
        <span class="guideRadioLabel">{label}</span>
      </label>
    </div>
  );
};

const RadioList = () => {
  const [val, setVal] = useState(1);
  console.log(val);

  return (
    <div class="cmp-webf guideFieldNode guideCheckBox radiotopup topup-type captionErrorBelowLabelLayout af-field-empty">
      <div class="guideRadioButtonGroupItems row" style={{}}>
        {[1, 2, 3].map((v, index) => (
          <Radio
            key={index}
            checked={v === val}
            value={v}
            onChange={(e) => setVal(e.target.value)}
          />
        ))}
      </div>
    </div>
  );
};

// const InputText = () => {
//   return (
//     <>
//       <div>
//         <div class="guideFieldLabel top">
//           <div class="label-container">
//             <label for="" id="" style={{ fontFamily: "Montserrat" }}>
//               Mobile
//             </label>
//           </div>
//         </div>
//         <div class="guidetextbox guidefield input-text">
//           <input placeholder="Test"></input>
//         </div>
//         <div class="input-error-msg" style={{ display: "none" }}>
//           Please enter a valid 8-digit Singapore mobile number starting with
//           either 8 or 9.
//         </div>
//       </div>
//       <div>
//         <div class="guideFieldLabel top">
//           <div class="label-container">
//             <label for="" id="" style={{ fontFamily: "Montserrat" }}>
//               Mobile
//             </label>
//           </div>
//         </div>
//         <div class="guidetextbox guidefield input-text input-error">
//           <input placeholder="Test"></input>
//         </div>
//         <div class="input-error-msg">
//           Please enter a valid 8-digit Singapore mobile number starting with
//           either 8 or 9.
//         </div>
//       </div>
//     </>
//   );
// };

const Button = () => {
  return (
    <>
      <button
        class="cmp-button cmp-button--primary button-default button-medium moveNext"
        type="button"
      >
        <span
          class="iconButton-label cmp-button__text"
          data-guide-button-label="true"
        >
          Next
        </span>
        <span
          style={{ marginTop: -6 }}
          class="iconButton-icon icons_space icon-dls-arrow-right"
        ></span>
      </button>
      &nbsp; &nbsp; &nbsp;
      <button
        class="cmp-button cmp-button--primary button-default button-medium moveNext"
        type="button"
        disabled="disabled"
      >
        <span
          class="iconButton-label cmp-button__text"
          data-guide-button-label="true"
        >
          Next
        </span>
        <span
          style={{ marginTop: -6 }}
          class="iconButton-icon icons_space icon-dls-arrow-right"
        ></span>
      </button>
    </>
  );
};

const DropDown = ({
  label = "Combo Box",
  isInvalid = false,
  errorMessage = null,
  items,
  value,
  onChange
}) => {
  const [valueText, setValueText] = useState("");
  // const [service, setService] = useState("");

  // const onChangeService = (value) => {
  //   console.log("value", value);
  //   setService(value);
  // };

  // const [valueLabel] = [
  //   { id: "1", text: "Hello" },
  //   { id: "2", text: "Hi" },
  //   { id: "3", text: "Hay" }
  // ].filter(({ id }) => id === service);

  useEffect(() => {
    const item = items.find((i) => i.id === value);
    setValueText(item ? item.text : "");
  }, [items, value]);

  const CustomInput = React.forwardRef(({ onClick }, ref) => (
    <InputText
      value={valueText}
      onClick={onClick}
      readOnly
      ref={ref}
      // cursor="pointer"
      isInvalid={isInvalid}
      iconComponent={
        <span className="icon-drop-down-arrow" onClick={onClick}>
          &nbsp;
        </span>
      }
    />
  ));

  return (
    <>
      <div>
        {label != null && (
          <div class="guideFieldLabel top">
            <div class="label-container">
              <label for="" id="" style={{ fontFamily: "Montserrat" }}>
                {label}
              </label>
            </div>
          </div>
        )}
        <div
          class={`guidetextbox guidefield input-text ${
            isInvalid ? "input-error" : ""
          }`}
        >
          {/* <div style={{ display: "flex", alignItems: "center" }}> */}
          <Dropdown
            onSelect={(value) => {
              onChange({ target: { value } });
            }}
            defaultValue={""}
          >
            <Dropdown.Toggle as={CustomInput} id="dropdown-custom-components" />

            <Dropdown.Menu
              style={{
                width: "100%",
                paddingLeft: 16,
                paddingRight: 16,
                border: "1px solid #9bbab8",
                height: 200,
                overflowY: "scroll"
              }}
            >
              {/* <Dropdown.Item value="">None</Dropdown.Item> */}
              {items.map((item, index) => (
                <>
                  <Dropdown.Item
                    eventKey={item.id}
                    key={item.id}
                    style={{
                      borderBottom:
                        index !== items.length - 1 ? "1px solid #80808045" : "",
                      paddingTop: 10,
                      paddingBottom: 10,
                      fontWeight: value === item.id ? 600 : 400
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between"
                      }}
                    >
                      <div>{item.text}</div>
                      {value === item.id && (
                        <div className="icon-drop-down-tick"></div>
                      )}
                    </div>
                  </Dropdown.Item>
                </>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {/* </div> */}
        <div
          class="input-error-msg"
          style={{ display: isInvalid ? "block" : "none" }}
        >
          {errorMessage}
        </div>
      </div>
    </>
  );
};

export default function Story() {
  const [mobile, setMobile] = useState("");
  const [selectedItemValue, setSelectedItemValue] = useState("");

  const itemStyle = { border: "1px solid blue", padding: 15 };
  const onChangeMobile = (e) => {
    setMobile(e.target.value);
  };

  const items = [
    { id: "1", text: "Hello" },
    { id: "2", text: "Hi" },
    { id: "3", text: "Hay0" },
    { id: "4", text: "Hay1" },
    { id: "5", text: "Hay2" },
    { id: "6", text: "Hay3" }
  ];

  return (
    <>
      <div style={{ width: 500, border: "1px solid black", padding: 15 }}>
        <div>
          <DropDown
            items={items}
            onChange={(v) => {
              // console.log(v);
              setSelectedItemValue(v.target.value);
            }}
            // isInvalid={true}
            // errorMessage={"Test Error Message"}
            value={selectedItemValue}
            // valueText={selectedItem.text}
            // valueId={selectedItem.id}
          />
          <br />
        </div>

        <div style={itemStyle}>
          <CardButton />
        </div>
        <div style={itemStyle}>
          <Disclaimer />
        </div>
        <div style={itemStyle}>
          <RadioList />
        </div>
        <div style={itemStyle}>
          {" "}
          <LinkButton text={"hello world"} />{" "}
        </div>
        <div style={itemStyle}>
          <InputText
            label="Mobile number"
            type="number"
            placeholder="Mobile number"
            value={99998888}
            onChange={onChangeMobile}
            //                     isInvalid={validateErrors[MOBILE_INDEX]}
            // errorMessage={validateErrors[MOBILE_INDEX]}
            isInvalid={true}
            errorMessage={"Invalid"}
          />
        </div>
        <div style={itemStyle}>
          <Instruction>
            <p>
              <b>Important notes</b>
            </p>
            <ul>
              <li>All fields are mandatory unless otherwise indicated.</li>
            </ul>
            <p>
              <b>To complete the form, you will need:</b>
            </p>
            <ul>
              <li>
                Your recipient’s NRIC, if you are making a cash top-up or CPF
                transfer to a loved one.
              </li>
              <li>
                <span class="triggerFreeContentModal additionalDocuments">
                  Additional documents
                </span>
                &nbsp;if you are making a CPF transfer to a recipient for the
                first time.
              </li>
              <li>
                Your banking app, payment app, or authentication token if you
                are using PayNow or eNETS.
              </li>
              <li>Your bank name and account number if you are using GIRO.</li>
            </ul>
          </Instruction>
        </div>
        <div style={itemStyle}>
          <Tooltip
            text={
              "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Repellat commodi dolorum quibusdam at incidunt adipisci dolorem blanditiis doloribus vero eius. Eius, debitis fuga est sunt nostrum quibusdam vitae adipisci deserunt!0"
            }
          />
        </div>
        <div
          class="separator aem-GridColumn aem-GridColumn--default--12"
          // style="height: auto;"
        >
          <div class="separator cmp-margin-bottom">
            <div class="cmp-separator">
              <hr class="cmp-separator__horizontal-rule cmp-separator--dotted" />
            </div>
          </div>
        </div>
        <div style={itemStyle}>
          <Button />
        </div>
      </div>

      <SeparatorLine />
      <BreadCrumb />

      <SeparatorLine />
      <StepperBar
        title={"Visit Centre"}
        // items={[
        //   { text: "One", current: true, complete: false },
        //   { text: "Two", current: false, complete: false }
        // ]}

        items={[
          { text: "One", current: false, complete: true },
          { text: "Two", current: true, complete: false }
        ]}
      />
    </>
  );
}
